import { Box, Text } from '@user-portal/wikr-components';
import styled from 'styled-components';

import { color } from '../../theme/selectors';

export const Container = styled(Box)`
    width: 100%;
    border-radius: 20px;

    ${({ $mb }) => Boolean($mb) && `margin-bottom: ${$mb}px;`};
`;

export const Badge = styled(Box)`
    width: 100%;
    border-radius: 20px 20px 0 0;
    ${({ theme, $backgroundColor }) => $backgroundColor && `background-color: ${theme[$backgroundColor]}`};
`;

export const Details = styled(Box)`
    width: 100%;
    border-radius: 0 0 20px 20px;
    ${({ $paddingTop }) => Boolean($paddingTop) && `padding-top: ${$paddingTop}px;`};
    ${({ $paddingX }) => Boolean($paddingX) && `padding-left: ${$paddingX}px; padding-right: ${$paddingX}px;`};
    ${({ $paddingBottom }) => Boolean($paddingBottom) && `padding-bottom: ${$paddingBottom}px;`};
    ${({ theme, $backgroundColor }) => $backgroundColor && `background-color: ${theme[$backgroundColor]}`};
`;

export const CrossedText = styled(Text)`
    text-decoration: line-through;
    text-decoration-color: ${color('text-main')};
    ${({ mb }) => Boolean(mb) && `margin-bottom: ${mb}px;`};
`;

export const Period = styled.span`
    font-size: 18px;
    font-weight: 500;
    line-height: 28px;
`;

export const SmallCurrency = styled.span`
    font-size: 21px;
`;

export const BigPrice = styled.span`
    margin-right: 6px;
    margin-left: 2px;
`;

export const PriceWithPeriod = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: center;
`;
